/* /tilbud/still/:key[?mode=compact] – ett stillbilde av prototypen, lagt ut i full bredde uten skalering. Brukes til å ta
   skjermbildene PDF-en trenger (public/tilbod/los/*.jpg): kalkyle · tilbud · ny · plan · innboks. full = rail + panel (1360×820),
   compact = bare flaten (1040×640). Ingen manus, ingen toast. */
import { useParams, useSearchParams } from "react-router-dom";
import { Shell } from "../components/proposal/los/LosShell";
import { LosSakApp } from "../components/proposal/los/LosSak";
import { IntakeApp } from "../components/proposal/los/LosIntake";
import { InboxView, PlanView } from "../components/proposal/los/LosViews";
import "../proposal.css";

const SIZE = { full: { w: 1360, h: 820 }, compact: { w: 1040, h: 640 } };

const STILLS = {
  kalkyle: (mode) => <LosSakApp beat={{ tab: "kalkyle", stage: "kalkyle", ms: 0 }} tab="kalkyle" mode={mode} still />,
  tilbud: (mode) => <LosSakApp beat={{ tab: "tilbud", stage: "kontroll", ms: 0 }} tab="tilbud" mode={mode} still />,
  ny: (mode) => <IntakeApp at={1} mode={mode} toast={null} />,
  plan: (mode) => (
    <Shell mode={mode} active="plan" title="Plan" testId="los-still-plan" view="plan">
      <PlanView beat={0} mode={mode} />
    </Shell>
  ),
  innboks: (mode) => (
    <Shell mode={mode} active="innboks" title="Innboks" testId="los-still-innboks" view="innboks">
      <InboxView beat={0} mode={mode} />
    </Shell>
  ),
};

export default function TilbudStillPage() {
  const { key } = useParams();
  const [sp] = useSearchParams();
  const mode = sp.get("mode") === "compact" ? "compact" : "full";
  const still = STILLS[key] || STILLS.kalkyle;
  const size = SIZE[mode];
  return (
    <div className="kvp kvl" style={{ background: "#fff", padding: 0, margin: 0 }}>
      <div className="mb-cine" style={{ width: size.w, height: size.h, overflow: "hidden" }} data-testid={`tilbod-still-${key}`} data-mode={mode}>
        {still(mode)}
      </div>
    </div>
  );
}
